import { useQuery } from '@tanstack/react-query';

import { backendApiSignCodesFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

export const useSignCodeQuery = (code: string) =>
  useQuery({
    ...backendApiSignCodesFindOneOptions({ path: { code } }),
    enabled: !!code,
  });
